import DeleteIcon from '@mui/icons-material/Delete';
import InfoIcon from '@mui/icons-material/Info';
import ModeEditOutlineIcon from '@mui/icons-material/ModeEditOutline';
import ShoppingBasketIcon from '@mui/icons-material/ShoppingBasket';
import { GridActionsCellItem } from '@mui/x-data-grid';

import TableActionButtons from '../../components/shared/TableActionButtons/TableActionButtons';

const useZoneTableColumns = (
  goToInfoPage,
  deleteItem,
  editItem,
  basketsItem,
  apiRef,
  columnPermissions = {},
) => {
  const {
    canGraph = false,
    canEdit = false,
    canViewBaskets = false,
    canDelete = false,
  } = columnPermissions;

  const canViewActions = canGraph || canEdit || canViewBaskets || canDelete;

  const columnsData = [
    {
      field: 'title',
      headerName: 'عنوان',
      flex: 1,
      minWidth: 160,
      resizable: true,
      editable: false,
      renderCell: params => {
        apiRef.current = params.api;
        return params.row.title;
      },
    },

    ...(canViewActions
      ? [
          {
            field: 'actions',
            headerName: 'عملیات',
            type: 'actions',
            flex: 0.5,
            align: 'right',
            minWidth: 300,

            getActions: params => {
              const buttons = [
                canGraph
                  ? {
                      label: 'جزئیات',
                      Icon: InfoIcon,
                      onClick: goToInfoPage(params.row),
                      color: 'primary',
                    }
                  : null,
                canEdit
                  ? {
                      label: 'ویرایش',
                      Icon: ModeEditOutlineIcon,
                      onClick: editItem(params.row),
                      color: 'info',
                    }
                  : null,
                canViewBaskets
                  ? {
                      label: 'سبد ها',
                      Icon: ShoppingBasketIcon,
                      onClick: basketsItem(params.row),
                      color: 'success',
                    }
                  : null,
              ].filter(Boolean);

              return [
                buttons.length ? (
                  <TableActionButtons key={10} buttons={buttons} />
                ) : null,
                canDelete ? (
                  <GridActionsCellItem
                    key={2}
                    icon={<DeleteIcon />}
                    label="حذف"
                    onClick={deleteItem(params.row)}
                    showInMenu
                  />
                ) : null,
              ].filter(Boolean);
            },
          },
        ]
      : []),
  ];

  return [columnsData];
};

export default useZoneTableColumns;
